export const initial = {
  nr: null,
  name: null,
  status: null,
  statusUnklar: null,
  statusUnklarBegruendung: null,
  bekanntSeit: null,
}

export const simpleTypes = {
  nr: 'number',
  name: 'string',
  status: 'number',
  statusUnklar: 'boolean',
  statusUnklarBegruendung: 'string',
  bekanntSeit: 'number',
}
